<div *ngIf="(sidebarData$ | async) as sidebar">
  <ul class="list-none m-0 py-2 space-y-1">
    <li *ngFor="let item of sidebar.items" class="flex items-center pb-0.5">
      <a
        class=" w-full rounded-lg no-underline hover:no-underline focus:no-underline flex items-center gap-2 px-4 py-3 text-gray-800
               bg-transparent hover:bg-gray-100 active:bg-gray-200 transition-all duration-150"
        [routerLink]="item.link"
        [relativeTo]="relativeRoute"
        routerLinkActive #rla="routerLinkActive"
        [ngClass]="{
          '!bg-gray-200 active:bg-gray-400 font-medium': rla.isActive || isProjectsRoute(item.link),
        }"
      >
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </a>
    </li>
  </ul>
</div>
